import { useEffect, useState } from "react";
import { apiURL, GetAnyList } from "../../WmUtils";
import useVersionStore from "../../../stores/versionStore";
import useDevMenuStore from "../../../stores/DevMenuStore";

const serverVersionURL = apiURL + "/server-version/";

const Versioning = () => {
  const { mobileVersion, serverVersion, setServerVersion } = useVersionStore();
  const { setDevMenu } = useDevMenuStore();
  // Handle fetching the server version and comparing it
  // with the mobile version to show update notification
  useEffect(() => {
    GetAnyList(serverVersionURL)
      .then((serverVersion) => {
        setServerVersion(serverVersion?.data.version);
      })
      .catch((error) => {
        console.error("Hiba a verzió lekérdezésnél: ", { cause: error });
      });
  }, []);

  const showUpdateNotification = serverVersion != mobileVersion;

  const [tapCount, setTapCount] = useState(0);

  // Reset tap count if user stops tapping for 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => setTapCount(0), 2000);
    return () => clearTimeout(timer);
  }, [tapCount]);

  const handleTap = () => {
    const newCount = tapCount + 1;
    if (newCount === 5) {
      setDevMenu(true);
      setTapCount(0);
    } else {
      setTapCount(newCount);
    }
  };

  return (
    <>
      <div
        onClick={handleTap}
        style={{
          MozUserSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
        }}
      >
        <div>Mobil verzió: {mobileVersion}</div>
        <div>Szerver verzió: {serverVersion}</div>
        {showUpdateNotification && (
          <div style={{ color: "red" }}>
            {"Új frissítés áll rendelkezésre, kérem telepítse!"}
          </div>
        )}
      </div>
    </>
  );
};

export default Versioning;
